import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  ApplicationHostTypeService,
  BaseToolTipComponent,
  ReferenceDataConstants,
  ReferenceDataLabels,
  ReferenceDataOptionLists,
  UserPermissions
} from 'rome-library';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CaseFilterStore } from '../../../interfaceTypes/broker/broker-case-hub/services/case-filter-store';
import { States } from '../../../shared';
import { UnreadMessageDto } from '../../models/unread-message-dto.model';
import { StateService } from '../../services/state.service';
import { UserNotificationService } from '../../services/user-notification.service';

@UntilDestroy()
@Component({
  selector: 'boi-messages-notifications',
  templateUrl: './messages-notifications.component.html'
})
export class MessagesNotificationsComponent extends BaseToolTipComponent implements OnInit {
  @Input() public isLeftMenuMessageNotification = false;
  @Output() public readonly notifyOnCaseHubReload = new EventEmitter();

  public readonly referenceDataLabels = ReferenceDataLabels;
  public readonly referenceDataOptionLists = ReferenceDataOptionLists;
  public readonly userPermissions = UserPermissions;
  public readonly states = States;

  public canViewAlertedCases = false;
  public unreadMessages: Array<UnreadMessageDto> = [];
  public isLeftMenuMessageOpened = false;
  public selectedCaseHash: string;
  public alertedCasesCount$: Observable<number>;

  constructor(
    private readonly caseFilterStore: CaseFilterStore,
    private readonly userNotificationService: UserNotificationService,
    private readonly stateService: StateService,
    private readonly router: Router,
    public readonly applicationHostTypeService: ApplicationHostTypeService,
    renderer: Renderer2,
    cdr: ChangeDetectorRef
  ) {
    super(renderer, cdr);
  }

  ngOnInit(): void {
    this.userNotificationService
      .unreadMessagesAsObservable()
      .pipe(untilDestroyed(this))
      .subscribe((messages) => {
        this.unreadMessages = messages;
      });

    this.alertedCasesCount$ = this.userNotificationService.numberOfAlertedCasesAsObservable();

    this.canViewAlertedCases =
      this.applicationHostTypeService.getInterfaceType() === ReferenceDataConstants.BROKER_INTERFACE_TYPE_ID;

    this.router.events
      .pipe(
        filter(
          (event) =>
            event instanceof NavigationEnd &&
            this.selectedCaseHash &&
            event.urlAfterRedirects.indexOf(this.selectedCaseHash) === -1
        ),
        untilDestroyed(this)
      )
      .subscribe((data: NavigationEnd) => {
        this.isLeftMenuMessageOpened = false;
        this.selectedCaseHash = undefined;
      });
  }

  public showOnlyAlertedCases(messagesTooltip): void {
    messagesTooltip.hide();
    this.caseFilterStore.showAlertedCases = true;
    this.caseFilterStore.notifyOnCaseHubReload();
    void this.router.navigate(['/', this.applicationHostTypeService.getCode(), States.BrokerCaseHub]);
  }

  public goToCaseMessages(caseNumber: string, messagesTooltip): void {
    if (messagesTooltip) {
      messagesTooltip.hide();
    }
    this.selectedCaseHash = caseNumber;
    this.stateService.goToCaseMessaging(caseNumber);
  }

  public toogleLeftMsgMenu(): void {
    this.isLeftMenuMessageOpened = !this.isLeftMenuMessageOpened;
  }
}
